import {Component, OnInit} from '@angular/core';
import {Household, HouseholdQuery} from '@core/state/household';
import {CircleDiagramData} from '@core/components/diagrams/circle-diagram/circle-diagram';
import * as changeCase from 'change-case';


@Component({
  selector: 'app-cost-per-month-circle-diagram',
  templateUrl: './cost-per-month-circle-diagram.component.html',
  styleUrls: ['./cost-per-month-circle-diagram.component.scss'],
})
export class CostPerMonthCircleDiagramComponent implements OnInit {
  household$ = this.householdQuery.select();

  constructor(private householdQuery: HouseholdQuery) {
  }

  ngOnInit() {
  }

  getData(household: Household): Array<CircleDiagramData> {
    const savings = [];

    for (const prop in household.savings) {
      if (household.savings.hasOwnProperty(prop)) {
        if (changeCase.capitalCase(prop) == "Mortgage") {
          savings.push(
            {
            label: "Hypotheek",
            value: household.savings[prop],
          });
        }
        else if (changeCase.capitalCase(prop) == "Life Insurance") {
          savings.push(
            {
            label: "Overlijdensrisicoverzekering",
            value: household.savings[prop],
          });
        }
        else {
          savings.push(
            {
            label: changeCase.capitalCase(prop),
            value: household.savings[prop],
          });
        }
      }
    }

    // If all values are 0
    let zeros = 0;
    for (const saving of savings) {
      if (saving.value === 0) {
        zeros++;
      }
    }

    if (zeros === savings.length) {
      for (const saving of savings) {
        if (saving.value === 0) {
          saving.value = 0.001;
        }
      }
    }

    return savings;
  }
  numberToCurrency(value) {
    let output = value.toLocaleString('nl-NL',
    {style: 'currency', currency: 'EUR'}
  );
  return output;
  }

}
